<template>
  <div v-show="show_tip" class="unsupportTip" v-on:click="dismiss($event)">
    <div class="wxcontainer" v-show="showWxTip">
      <p class="wxtip-txt">{{ t('tip.unsupportedOpenInApp.weixin.title') }}</p>
      <p class="wxtip-txt-1">{{ t('tip.unsupportedOpenInApp.weixin.step1') }}</p>
      <p class="wxtip-txt-1">{{ t('tip.unsupportedOpenInApp.weixin.step2') }}</p>
    </div>
    <div class="wxcontainer" v-show="showQQTip">
      <p class="wxtip-txt">{{ t('tip.unsupportedOpenInApp.qq.title') }}</p>
      <p class="wxtip-txt-1">{{ t('tip.unsupportedOpenInApp.qq.step1') }}</p>
      <p class="wxtip-txt-1">{{ t('tip.unsupportedOpenInApp.qq.step2') }}</p>
    </div>
    <div class="wxcontainer" v-show="showWbTip">
      <p class="wxtip-txt">{{ t('tip.unsupportedOpenInApp.weibo.title') }}</p>
      <p class="wxtip-txt-1">{{ t('tip.unsupportedOpenInApp.weibo.step1') }}</p>
      <p class="wxtip-txt-1">{{ t('tip.unsupportedOpenInApp.weibo.step2') }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import { defineProps, ref, onMounted, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps<{
  show_tip: boolean;
}>();

const emit = defineEmits(['dimiss']);
const { t } = useI18n();

const showWxTip = ref(false);
const showWbTip = ref(false);
const showQQTip = ref(false);

onMounted(() => {
  if (DeviceEnvUtil.isWeixin()) {
    showWxTip.value = true;
    showWbTip.value = false;
    showQQTip.value = false;
  } else if (DeviceEnvUtil.isQQ()) {
    showWxTip.value = false;
    showWbTip.value = false;
    showQQTip.value = true;
  } else if (DeviceEnvUtil.isWeibo()) {
    showWxTip.value = false;
    showWbTip.value = true;
    showQQTip.value = false;
  }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dismiss = (event: any) => {
  event.stopPropagation();
  emit('dimiss');
};
</script>

<style scoped>
.unsupportTip {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgb(0 0 0 / 80%);
}

.wxcontainer {
  margin-left: 100px;
  width: 100%;
  height: 100%;
}

.wxtip-txt {
  margin-top: 70px;
  font-size: 18px;
  text-align: left;
  color: #ffffff;
  line-height: 1.8;
  align-self: start;
}

.wxtip-txt-1 {
  margin-top: 7px;
  font-size: 16px;
  text-align: left;
  color: #ffffff;
  line-height: 1.8;
}
</style>
